var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
/**
 * Adds 'hidden' property to a @param Component.
 *
 * `hidden` hides node conditionally as an alternative to conditional rendering
 * which completely unmounts node from DOM.
 */
export const withHidden = (Component) => {
    return function WithHiddenHocContainer(_a) {
        var { hidden } = _a, props = __rest(_a, ["hidden"]);
        return (React.createElement("div", { hidden: hidden },
            React.createElement(Component, Object.assign({}, props))));
    };
};
